// components/LoadingProgressBar.js
import React, { useState, useEffect } from 'react';

const LoadingProgressBar = ({ 
  isLoading = false, 
  progress = 0, 
  showPercentage = true,
  className = '',
  color = 'blue',
  height = 'h-2'
}) => {
  const [displayProgress, setDisplayProgress] = useState(0);

  // Smooth progress animation
  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setDisplayProgress(prev => {
          if (prev < progress) {
            return Math.min(prev + 2, progress);
          }
          return prev;
        });
      }, 50);

      return () => clearInterval(interval);
    } else {
      setDisplayProgress(0);
    }
  }, [isLoading, progress]);

  if (!isLoading && displayProgress === 0) {
    return null;
  }

  const colorClasses = {
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    purple: 'bg-purple-600',
    orange: 'bg-orange-600'
  };

  return (
    <div className={`w-full ${className}`}>
      {/* Progress Bar */}
      <div className={`w-full bg-gray-200 rounded-full ${height} overflow-hidden`}>
        <div 
          className={`${height} ${colorClasses[color]} rounded-full transition-all duration-300 ease-out`}
          style={{ width: `${displayProgress}%` }}
        />
      </div>
      
      {/* Percentage Text */}
      {showPercentage && (
        <div className="flex justify-between items-center mt-2 text-sm text-gray-600">
          <span>Loading promotions...</span>
          <span className="font-medium">{Math.round(displayProgress)}%</span>
        </div>
      )}
    </div>
  );
};

export default LoadingProgressBar;